"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.postMessageBypass = exports.parentShuftiVerification = exports.parentUnblockUI = exports.parentBlockUI = exports.parentRedirectTo = void 0;
const parentRedirectTo = (url) => {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
        event: 'redirect-to',
        returnUrl: url,
    }, '*');
};
exports.parentRedirectTo = parentRedirectTo;
const parentBlockUI = (msg) => {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
        event: 'block-ui',
        message: msg,
    }, '*');
};
exports.parentBlockUI = parentBlockUI;
const parentUnblockUI = () => {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
        event: 'unblock-ui',
    }, '*');
};
exports.parentUnblockUI = parentUnblockUI;
const parentShuftiVerification = () => {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage({
        event: 'shufti_verification',
    }, '*');
};
exports.parentShuftiVerification = parentShuftiVerification;
// Post a message from GPAS to SCA, bypassing TV1.
function postMessageBypass(message, targetOrigin = '*') {
    var _a;
    (_a = window === null || window === void 0 ? void 0 : window.parent) === null || _a === void 0 ? void 0 : _a.postMessage(Object.assign({ event: 'bypass' }, message), targetOrigin);
}
exports.postMessageBypass = postMessageBypass;
